















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { IDocType } from "@/@types/admin/guest/user";
import identity_cards from "@/config/identity/identity_cards";
import {
  requiredIf,
  numeric,
  maxLength,
  minLength,
} from "vuelidate/lib/validators";

@Component({
  mixins: [validationMixin],
  validations: {
    doc: {
      required: requiredIf(function (this: any) {
        return this.required;
      }),
      numeric,
      maxLength: maxLength(9),
      minLength: minLength(9),
    },
  },
})
export default class Document0 extends Vue {
  @Prop({ type: String, default: "" }) document!: string;
  @Prop({ type: String, default: "" }) type!: string;
  @Prop({ type: Boolean, default: true }) required!: boolean;

  doc = "";
  number = true;
  foo = 10;

  get doctype(): IDocType | null {
    const type = identity_cards.find((el) => el._id == this.type);
    return type ? type : null;
  }

  @Watch("doc")
  processingDoc(): void {
    this.doc = this.doc.replace(/\s+/g, "");
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }
    if (!this.isValid(this.doc)) return;
    this.$emit("number", this.doc);
  }

  isValid(doc: string): boolean {
    if (doc.match(/^\d{9}$/)) return true;
    else return false;
  }

  @Watch("document")
  createDoc(): void {
    if (!this.document) return;
    this.doc = this.document;
  }

  mounted(): void {
    this.createDoc();
  }
}
